import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import FormProvider from "../../../components/hook-form/form-provider";
import { UseFormReturn } from "react-hook-form";
import { RHFTextField } from "../../../components/hook-form";
import { LoadingButton } from "@mui/lab";

type Props = {
    open: boolean;
    onClose: VoidFunction;
    methods: UseFormReturn<{
        code: string;
        name: string;
    }, any, undefined>,
    onSubmit: VoidFunction;
    isSubmitting: boolean;
}

const BranchDialogComponent = ({ open, onClose, methods, onSubmit, isSubmitting }: Props) => {

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}>Cadastrar Filial</DialogTitle>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
                    <RHFTextField
                        label="Código da Filial"
                        name="code"
                        fullWidth
                        sx={{ mb: 3 }}
                    />
                    <RHFTextField
                        label="Nome da Filial"
                        name="name"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        loading={isSubmitting}
                    >
                        Cadastrar Filial
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );

}

export default BranchDialogComponent;